import { render } from "./AdminSenders.vue?vue&type=template&id=f4dd05d4"
import script from "./AdminSenders.vue?vue&type=script&lang=js"
export * from "./AdminSenders.vue?vue&type=script&lang=js"

import "./AdminSenders.vue?vue&type=style&index=0&id=f4dd05d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__